export default {
  Text: 1,
  Boolean: 2,
  Integer: 3,
  Float: 4,
  Date: 5,
  Time: 6,
  LOV: 7,
  URL: 8
}
